import { Button, Grid } from "@mui/material";
import axios from "axios";
import { MAIN_URL } from "../../Configurations/Urls";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import toast from "react-hot-toast";
import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import useInternDataStore from "../../Zustand/Store/useInternDataStore";

const SubmitButtonIntern = ({ mode }) => {
  let {
    Intern,
    setInternErrors,
    setLanguageErrors,
    setEducationError,
    setFamilyError,
    setAddressError,
    setContactError,
    setExperienceError,
    setMedicalError,
    setPaymentMethodError,
    Education,
    EducationErrors,
    LanguageErrors,
    FamilyErrors,
    AddressErrors,
    ContactErrors,
    ExperienceErrors,
    MedicalErrors,
    PaymentMethodErrors,
    Language,
    setIntern,
    Family,
    Address,
    Contact,
    Experience,
    Medical,
    PaymentMethod,
    resetData,
    setEducation,
    setLanguage,
    setFamily,
    setAddress,
    setContact,
    setExperience,
    setMedical,
    setPaymentMethod,
    DocumentErrors,
    setDocument,
    Document,
    setDocumentError,
  } = useInternDataStore();

  const { userData } = useAuthStore();
  const org = userData?.organization;

  let navigate = useNavigate();

  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  console.log("is is ", id);

  console.log("Intern:", Intern);
  console.log("Education:", Education);
  console.log("Language:", Language);
  console.log("Family:", Family);
  console.log("Address:", Address);
  console.log("Contact:", Contact);
  console.log("Experience:", Experience);
  console.log("Medical:", Medical);
  console.log("PaymentMethod:", PaymentMethod);
  console.log("document is ", Document);

  console.log("education errtor", EducationErrors);

  console.log("language  errtor ", LanguageErrors);

  console.log("family  errtor", FamilyErrors);

  console.log("address  errtor ", AddressErrors);
  console.log("document  errtor ", DocumentErrors);

  console.log("contact  errtor", ContactErrors);
  console.log("experience  errtor", ExperienceErrors);

  console.log("medical  errtor", MedicalErrors);
  console.log("payment   errtor", PaymentMethodErrors);

  const validateForm1 = () => {
    const errors = {};

    if (!Intern.intern_code)
      errors.intern_code = "Intern Code is required.";

    if (!Intern.first_name) errors.first_name = "First Name is required.";

    if (!Intern?.date_of_birth)
      errors.date_of_birth = "Date of Birth is required.";

    if (!Intern?.gender) errors.gender = "Gender is required.";

    if (!Intern?.marital_status)
      errors.marital_status = "Marital Status is required.";

    if (!Intern?.organization_department_id)
      errors.organization_department_id = "Department is required.";

    if (!Intern?.organization_department_location_id)
      errors.organization_department_location_id = "Location is required.";

    if (!Intern.organization_work_shift_id)
      errors.organization_work_shift_id = "Workshift is required.";

    if (!Intern.organization_internship_type_id )
      errors.organization_internship_type_id  = "Internship Type is required.";


    if (!Intern.organization_internship_stage_id )
      errors.organization_internship_stage_id  =
        "Internship Stage is required.";

    if (!Intern.internship_start_date)
      errors.internship_start_date = "Start Date is required.";

    if (!Intern.internship_end_date)
      errors.internship_end_date = "End Date is required.";

    // Optional: Validate specific formats
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (Intern.date_of_birth && !dateRegex.test(Intern.date_of_birth)) {
      errors.date_of_birth = "Date of Birth must be in YYYY-MM-DD format.";
    }
    if (Intern.internship_start_date && !dateRegex.test(Intern.internship_start_date)) {
      errors.internship_start_date = "Date of Joining must be in YYYY-MM-DD format.";
    }
     if (Intern.internship_end_date && !dateRegex.test(Intern.internship_end_date)) {
      errors.internship_end_date = "End Date  must be in YYYY-MM-DD format.";
    }

    if (Object.keys(errors)?.length > 0) {
      const firstKey = Object.keys(errors)[0];
      const firstError = errors[firstKey];
      toast.error(firstError); // ✔ Show most recent (first) error
      setInternErrors(errors);
      return false;
    }
    setInternErrors({});
    return true;
  };

  const validateForm2 = () => {
    const allErrors = {};
    let firstErrorMessage = null;

    const isFilled = (item) =>
      item.organization_education_level_id ||
      item.organization_education_degree_id ||
      item.organization_education_stream_id ||
      item.institute_name ||
      item.board_university_name ||
      (item.marks_percentage !== "" &&
        item.marks_percentage !== null &&
        item.marks_percentage !== undefined) ||
      item.year_of_passing ||
      item.is_pursuing ||
      item.organization_person_id ||
      item.organization_id;

    const filteredEducation = Education.filter(isFilled);

    // Now validate only filled entries
    filteredEducation.forEach((edu, index) => {
      const errors = {};

      if (!edu.organization_education_level_id)
        errors.organization_education_level_id = "Education Level is required.";

      // if (
      //   edu.organization_education_degree_id &&
      //   edu.organization_education_stream_id
      // ) 

      if (!edu.institute_name)
        errors.institute_name = "Institute name is required.";

      if (!edu.board_university_name)
        errors.board_university_name = "Board name is required.";

      if (Object.keys(errors)?.length > 0) {
        allErrors[index] = errors;
        if (!firstErrorMessage) {
          const firstKey = Object.keys(errors)[0];
          firstErrorMessage = errors[firstKey];
        }
      }
    });

    if (firstErrorMessage) {
      toast.error(firstErrorMessage);
      setEducationError(allErrors);
      return false;
    }

    setEducationError({});
    setEducation(filteredEducation);

    return true;
  };

  const validateForm3 = () => {
    const allErrors = {};
    let firstError = null;

    const isFilled = (item) =>
      item.organization_person_id  ||
      item.language_id  ||
      item.can_read ||
      item.can_write ||
      item.can_speak ||
      item.is_native ||
      item.description ||
      item.organization_id;

    const filtered = Language.filter(isFilled);

    filtered.forEach((item, idx) => {
      const errors = {};
      if (!item.language_id) errors.language_id = "Language is required.";

      if (Object.keys(errors)?.length > 0) {
        allErrors[idx] = errors;
        if (!firstError) firstError = errors[Object.keys(errors)[0]];
      }
    });

    if (firstError) {
      toast.error(firstError);
      setLanguageErrors(allErrors);
      setLanguage(filtered);
      return false;
    }

    setLanguageErrors({});
    setLanguage(filtered);
    return true;
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  };

  const validateForm4 = () => {
    const allErrors = {};
    let firstError = null;

    const isFilled = (item) =>
      item.address_line1 ||
      item.address_line2 ||
      item.address_line3 ||
      item.general_city_id ||
      item.postal_code ||
      item.organization_person_id ||
      item.organization_id;

    const filtered = Address.filter(isFilled);

    filtered.forEach((item, idx) => {
      const errors = {};
     

    
      if (!item.address_line1)
        errors.address_line1 = "Employee Address is required.";

      if (!item.general_city_id) errors.general_city_id = "City is required.";

      if (!item.postal_code) errors.postal_code = "Postal is required.";

      if (Object.keys(errors)?.length > 0) {
        allErrors[idx] = errors;
        if (!firstError) firstError = errors[Object.keys(errors)[0]];
      }
    });

    if (firstError) {
      toast.error(firstError);
      setAddressError(allErrors);
      setAddress(filtered);
      return false;
    }

    setAddressError({});
    setAddress(filtered);
    return true;
  };

  const validateForm5 = () => {
    const allErrors = {};
    let firstError = null;

    const isFilled = (item) =>
      item.organization_person_id  ||
      item.personal_phone_number ||
      item.alternate_personal_phone_number||
      item.personal_email ||
      item.emergency_person_name_1 ||
      item.emergency_person_relation_1 ||
      item.emergency_person_phone_number_1 ||
      item.organization_id;

    const isValidPhone = (phone) => /^(\+?\d{1,3}[- ]?)?\d{10}$/.test(phone);
    const isValidEmail = (email) => {
      // Local part + @ + domain + TLD (letters only, min 2)
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      return emailRegex.test(email.trim());
    };

    const validContactMethods = ["phone", "email", "message"];

    const filtered = Contact.filter(isFilled);

    filtered.forEach((item, idx) => {
      const errors = {};

      if (!item.personal_phone_number) {
        errors.personal_phone_number = "Personal phone number is required.";
      } else if (!isValidPhone(item.personal_phone_number)) {
        errors.personal_phone_number = "Enter a valid 10-digit phone number.";
      }

      if (!item.personal_email) {
        errors.personal_email = "Personal email is required.";
      } else if (!isValidEmail(item.personal_email)) {
        errors.personal_email = "Enter a valid personal email address.";
      }

      

      if (!item.emergency_person_name_1)
        errors.emergency_person_name_1 =
          "Emergency contact  name is required.";

  

      if (!item.emergency_person_phone_number_1) {
        errors.emergency_person_phone_number_1 =
          "Emergency contact  phone is required.";
      } else if (!isValidPhone(item.emergency_person_phone_number_1)) {
        errors.emergency_person_phone_number_1 =
          "Enter a valid emergency contact  phone number.";
      }

      if (!item.emergency_person_relation_1)
        errors.emergency_person_relation_1 =
          "Relation with emergency Person  is required.";

    

      if (Object.keys(errors)?.length > 0) {
        allErrors[idx] = errors;
        if (!firstError) firstError = errors[Object.keys(errors)[0]];
      }
    });

    if (firstError) {
      toast.error(firstError);
      setContactError(allErrors);
      setContact(filtered);
      return false;
    }

    setContactError({});
    setContact(filtered);
    return true;
  };

  const validateForm6 = () => {
    const allErrors = {};
    let firstError = null;

    const isFilled = (item) =>
      item.organization_name ||
      item.work_title ||
      item.organization_person_id ||
      item.work_mode ||
      item.experience_type ||
      item.compensation_status ||
      item.general_industry_id ||
      item.start_date ||
      item.end_date ||
      item.currency_code ||
      item.compensation_amount ||
      item.location ||
      item.reporting_manager_name ||
      item.reporting_manager_contact ||
      item.description ||
      item.is_verified ||
      item.verified_by ||
      item.verification_date ||
      item.verification_notes ||
      item.organization_id;

    const filtered = Experience.filter(isFilled);

    filtered.forEach((item, idx) => {
      const errors = {};

      if (!item.experience_type)
        errors.experience_type = "Experience Type is required.";

      if (!item.organization_name)
        errors.organization_name = "Company Name is required.";

      if (!item.start_date) errors.start_date = "start date is required.";

      if (!item.end_date) errors.end_date = "start date is required.";

      if (!item.general_industry_id)
        errors.general_industry_id = "Industry is required.";

      if (!item.location) errors.location = "Loaction is required.";

      if (!item.work_title) errors.work_title = "work title is required.";

      if (!item.work_mode) errors.work_mode = "work mode is required.";

      if (!item.compensation_status)
        errors.compensation_status = "work status is required.";

      if (item.is_verified) {
        if (!item.verified_by)
          errors.verified_by = "Verified Person Name is required";
        if (!item.verification_date)
          errors.verification_date = "Verification Date is required";
      }

      if (Object.keys(errors)?.length > 0) {
        allErrors[idx] = errors;
        if (!firstError) firstError = errors[Object.keys(errors)[0]];
      }
    });

    if (firstError) {
      toast.error(firstError);
      setExperienceError(allErrors);
      setExperience(filtered);
      return false;
    }

    setExperienceError({});
    setExperience(filtered);
    return true;
  };

  const validateForm7 = () => {
    const allErrors = {};
    let firstError = null;

    const isFilled = (item) =>
      item.organization_person_id ||
      item.blood_group ||
      item.allergies ||
      item.diseases ||
      item.disability_status ||
      item.disability_description ||
      item.is_fit_for_duty ||
      item.last_health_check_date ||
      item.medical_notes ||
      item.organization_id;

    const filtered = Medical.filter(isFilled);

    filtered.forEach((item, idx) => {
      const errors = {};

      if (!item.blood_group) errors.blood_group = "Blood Group is required.";

      if (!item.disability_status)
        errors.disability_status = "Disability Status is required.";

      if (Object.keys(errors)?.length > 0) {
        allErrors[idx] = errors;
        if (!firstError) firstError = errors[Object.keys(errors)[0]];
      }
    });

    if (firstError) {
      toast.error(firstError);
      setMedicalError(allErrors);
      setMedical(filtered);
      return false;
    }

    setMedicalError({});
    setMedical(filtered);
    return true;
  };

  const validateForm8 = () => {
    const allErrors = {};
    let firstError = null;

    const isFilled = (item) =>
      item.organization_id ||
      item.organization_person_id ||
      item.account_holder_name ||
      item.bank_name ||
      item.branch_name ||
      item.ifsc_code ||
      item.account_number ||
      item.swift_code ||
      item.is_primary ||
      item.iban_number ||
      item.upi_id ||
      item.wallet_id

    const uriPattern =
      /^(upi:\/\/pay\?.+|https?:\/\/[\w\-._~:/?#@!$&'()*+,;=%]+|bitcoin:[\w]+|BCD[\w\d]+)$/i;

    const filtered = PaymentMethod.filter(isFilled);

    filtered.forEach((item, idx) => {
      const errors = {};

      if (!item.bank_name) errors.bank_name = "Bank Name is required.";
      if (!item.account_holder_name)
        errors.account_holder_name = "A/C holder Name is required.";

      if (!item.account_number) {
        errors.account_number = "A/C No. is required.";
      } else if (!/^\d+$/.test(item.account_number)) {
        errors.account_number = "A/C No. must be numeric.";
      } else if (item.account_number?.length < 9) {
        errors.account_number = "A/C No. must be at least 9 digits.";
      } else if (item.account_number?.length > 18) {
        errors.account_number = "A/C No. must not exceed 18 digits.";
      }
      if (item.upi_id) {
        errors.upi_id = "Enter a valid payment UPI ID (UPI, PayPal, etc.)";
      }
      if (!item.ifsc_code) {
        errors.ifsc_code = "IFSC Code is required";
      } 
      
      if (Object.keys(errors)?.length > 0) {
        allErrors[idx] = errors;
        if (!firstError) firstError = errors[Object.keys(errors)[0]];
      }
    });

    if (firstError) {
      toast.error(firstError);
      setPaymentMethodError(allErrors);
      setPaymentMethod(filtered);
      return false;
    }

    setPaymentMethodError({});
    setPaymentMethod(filtered);
    return true;
  };

  const validateForm9 = () => {
    const allErrors = {};
    let firstError = null;

    const isFilled = (item) =>
      item.organization_person_id ||
      item.name ||
      item.relationship ||
      item.phone_number ||
      item.email ||
      item.description ||
      item.date_of_birth ||
      item.is_dependent ||
      item.organization_id;

    const filtered = Family.filter(isFilled);

    filtered.forEach((item, idx) => {
      const errors = {};

      if (!item.name) errors.name = "Name of Relative is required.";
      if (!item.relationship) errors.relationship = "Relationship is required.";
      

      if (item.email && !isValidEmail(item.email)) {
        errors.email = "Enter a valid  email address.";
      }

      if (Object.keys(errors)?.length > 0) {
        allErrors[idx] = errors;
        if (!firstError) firstError = errors[Object.keys(errors)[0]];
      }
    });

    if (firstError) {
      toast.error(firstError);
      setFamilyError(allErrors);
      setFamily(filtered);
      return false;
    }

    setFamilyError({});
    setFamily(filtered);
    return true;
  };

  function printFormData(formData) {
    console.log("----- FormData Contents -----");
    for (let pair of formData.entries()) {
      console.log("helloe ", pair[0], ":", pair[1]);
    }
    console.log("-----------------------------");
  }

  const validateForm10 = () => {
    const allErrors = {};
    let firstError = null;

    const isFilled = (item) =>
      item.organization_person_id ||
      item.intern_document_type_id ||
      item.organization_id ||
      item.document_name ||
      item.document_url ||
      item.document_size_kb||
      item.organization_employee_profile_section_id;

    const filtered = Document.filter(isFilled);

    filtered.forEach((item, idx) => {
      const errors = {};

      if (!item.intern_document_type_id) {
        errors.intern_document_type_id = "Document Type is required.";
      }

      if (!item.document_name) {
        errors.document_name = "Document Name  is required.";
      }
    });

    if (firstError) {
      toast.error(firstError);
      setDocumentError(allErrors);
      setDocument(filtered);
      return false;
    }

    setDocumentError({});
    setDocument(filtered);
    return true;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    // Extract the YYYY-MM-DD portion from ISO string
    return dateStr.split("T")[0];
  };

  // Helper function to merge person data from org_persons.person into intern object
  const mergePersonDataIntoIntern = (internData) => {
    if (!internData) {
      return internData;
    }

    const orgPersons = internData.org_persons || internData.OrgPersons || {};
    const person = orgPersons.person || orgPersons.Person || {};
    
    // Merge person data into intern, prioritizing person data if intern fields are null/empty
    // Note: date_of_birth and internship_start_date will be formatted after merging
    return {
      ...internData,
      // Intern code from org_persons.person_code
      intern_code: internData.intern_code || orgPersons.person_code || "",
      // Person fields from org_persons.person
      first_name: internData.first_name || person?.first_name || "",
      middle_name: internData.middle_name !== null && internData.middle_name !== undefined 
        ? internData.middle_name 
        : (person?.middle_name || ""),
      last_name: internData.last_name || person?.last_name || "",
      date_of_birth: internData.date_of_birth || person?.date_of_birth || "",
      gender: internData.gender || person?.gender || "",
      marital_status: internData.marital_status || person?.marital_status || "",
      profile_image_url: person?.profile_image_url || internData.profile_image_url || "",
      internship_start_date: internData.internship_start_date || orgPersons.organization_join_date || "",
    };
  };

  const resolveDepartmentId = (internData, fallbackId = "") => {
    const fromRelation =
      internData?.department_location?.[0]?.organization_department_id ??
      internData?.department_location?.organization_department_id ??
      internData?.DepartmentLocation?.[0]?.organization_department_id ??
      internData?.organization_department_id;
    return fromRelation || fallbackId || "";
  };

  // Preserve department/location (and other profile fields) when API responses omit them,
  // so a store1/store2 validation error never blanks those selects.
  const buildInternStateFromApiResponse = (apiIntern, currentIntern = {}) => {
    const merged = mergePersonDataIntoIntern(apiIntern) || {};

    merged.date_of_birth = formatDate(merged.date_of_birth);
    merged.internship_start_date = formatDate(merged.internship_start_date);
    merged.internship_end_date = formatDate(merged.internship_end_date);

    const departmentId = resolveDepartmentId(
      merged,
      currentIntern?.organization_department_id
    );

    return {
      ...currentIntern,
      ...merged,
      organization_department_id: departmentId,
      organization_department_location_id:
        merged.organization_department_location_id ||
        currentIntern.organization_department_location_id ||
        "",
      organization_unit_id:
        merged.organization_unit_id || currentIntern.organization_unit_id || "",
      organization_internship_type_id:
        merged.organization_internship_type_id ||
        currentIntern.organization_internship_type_id ||
        "",
      organization_internship_stage_id:
        merged.organization_internship_stage_id ||
        currentIntern.organization_internship_stage_id ||
        "",
      organization_internship_status_id:
        merged.organization_internship_status_id ||
        currentIntern.organization_internship_status_id ||
        "",
      organization_work_shift_id:
        merged.organization_work_shift_id ||
        currentIntern.organization_work_shift_id ||
        "",
      mentor_organization_person_id:
        merged.mentor_organization_person_id ||
        currentIntern.mentor_organization_person_id ||
        "",
    };
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      if (mode === "edit"  || mode === "view") {
        try {
          const response = await axios.get(
            `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-store/update/${id}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          console.log("Employee fetched:", response?.data);
          
          // Merge person data from org_persons.person into intern BEFORE formatting dates
          const mergedInternData = buildInternStateFromApiResponse(
            response.data.intern,
            Intern || {}
          );

          setIntern(mergedInternData);

          // setIntern(response.data.intern);
          // response?.data?.education?.organization_education_degree_id = response?.data?.education?.degree?.[0]?.organization_education_degree_id
          
          // setEducation(response?.data.education)
          setEducation(
            response.data.education?.length > 0
              ? response.data.education
              : [
                  {
                     organization_education_level_id:"",
                        organization_education_degree_id:"",
                        organization_education_stream_id:"",
                        institute_name:"",
                        board_university_name:"",
                        marks_percentage:"",
                        year_of_passing:"",
                        is_pursuing:"",
                        organization_person_id:"",
                        organization_id:""
                  },
                ]
          );
          setLanguage(
            response.data.language?.length > 0
              ? response.data.language
              : [
                  {
                    person_language_id: "",
                    organization_person_id: "",
                    language_id : "",
                    can_read: false,
                    can_write: false,
                    can_speak: false,
                    is_native: false,
                    description: "",
                    organization_id: "",
                  },
                ]
          );


          // last i did here  

          response.data.family = response.data?.family?.map((item) => ({
            ...item,
            date_of_birth:
              item.date_of_birth == null
                ? null
                : formatDate(item.date_of_birth),
          }));

          setFamily(
            response.data.family?.length > 0
              ? response.data.family
              : [
                  {
                    person_family_member_id : "",
                    organization_person_id : "",
                    name: "",
                    relationship: "",
                    phone_number: "",
                    date_of_birth: "",
                    is_dependent: "",
                    gender:"",
                    email: "",
                    organization_id: "",
                  },
                ]
          );

          setAddress(
            response.data.address?.length > 0
              ? response.data.address
              : [
                  {
                 
                    address_line1: "",
                    address_line2: "",
                    address_line3: "",
                    general_city_id: "",
                    postal_code: "",
                    organization_person_id: "",
                    organization_id: "",
                  },
                ]
          );
          setContact(
            response.data.contact?.length > 0
              ? response.data.contact
              : [
                  {
                    organization_person_id : "",
                    personal_phone_number: "",
                    alternate_personal_phone_number: "",
                    personal_email: "",
                    emergency_person_name_1: "",
                    emergency_person_relation_1: "",
                    emergency_person_phone_number_1: "",
                    organization_id: "",
                  },
                ]
          );
          setExperience(
            response.data.experience?.length > 0
              ? response.data.experience
              : [
                  {
                    person_experience_id : "",
                    organization_person_id : "",
                    organization_name: "",
                    work_title: "",
                    experience_type: "",
                    description: "",
                    general_industry_id: "",
                    work_mode: "",
                    start_date: "",
                    end_date: "",
                    currency_code: "",
                    location: "",
                    compensation_status: "",
                    compensation_amount: "",
                    reporting_manager_name: "",
                    reporting_manager_contact: "",
                    is_verified: false,
                    verified_by: "",
                    verification_date: "",
                    verification_notes: "",
                    organization_id: "",
                  },
                ]
          );
          setMedical(
            response.data.medical?.length > 0
              ? response.data.medical
              : [
                  {
                    person_medical_id : "",
                    organization_person_id : "",
                    blood_group: "",
                    allergies: "",
                    diseases: "",
                    disability_status: "",
                    disability_description: "",
                    is_fit_for_duty: false,
                    last_health_check_date: "",
                    medical_notes: "",
                    organization_id: "",
                  },
                ]
          );
          setPaymentMethod(
            response.data.payment_method?.length > 0
              ? response.data.payment_method
              : [
                  {
                    intern_bank_account_id : "",
                    organization_id: "",
                    organization_person_id : "",
                    account_holder_name: "",
                    bank_name: "",
                    ifsc_code: "",
                    swift_code:"",
                    branch_name:"",
                    iban_number:"",
                    upi_id:"",
                    wallet_id:"",
                    account_number: "",
                    is_primary: "",
                  },
                ]
          );

          setDocument(
            response.data.document?.length > 0
              ? response?.data?.document?.map((item) => {
                  return {
                    ...item,

                    organization_employee_profile_section_id:
                      item.section_link.map((i) => {
                        return i.profile_section
                          .organization_employee_profile_section_id;
                      }),
                  };
                })
              : [
                  {
                    organization_id: "",
                    organization_person_id : "",
                    document_name: "",
                    document_url: "",
                    intern_document_type_id : "",
                    document_size_kb:"",
                    organization_employee_profile_section_id: "",
                  },
                ]
          );
        } catch (error) {
          console.error("Error fetching Intern data:", error);
        }
      }
    };

    fetchEmployeeData();
  }, [mode, id]);

  const handleSubmit = async () => {
    try {
      if (!validateForm1()) return;

      // check has education
      // let sectionData = {};

      let FiiledEducation = Education?.filter(
        (item) =>
          item.organization_education_level_id != "" ||
          item.organization_education_degree_id != "" ||
          item.organization_education_stream_id != "" ||
          item.institute_name != "" ||
          item.board_university_name != "" ||
          item.marks_percentage != "" ||
          item.year_of_passing != "" ||
          item.is_pursuing != "" ||
          item.organization_person_id  != "" ||
          item.organization_id != ""
      ).map((item) => {
        const pursuing = Boolean(item?.is_pursuing);
        return {
          ...item,
          year_of_passing: pursuing ? "" : item.year_of_passing,
        };
      });

      let FiiledLanguage = Language?.filter(
        (item) =>
          item.organization_person_id  != "" ||
          item.language_id  != "" ||
          item.can_read != false ||
          item.can_write != false ||
          item.can_speak != false ||
          item.is_native != false ||
          item.description != "" ||
          item.organization_id != ""
      );

      let FiiledFamily = Family?.filter(
        (item) =>
          item.organization_person_id  != "" ||
          item.name != "" ||
          item.relationship != "" ||
          item.phone_number != "" ||
          item.date_of_birth != "" ||
          item.gender != "" ||
          item.email != "" ||
          item.is_dependent != "" ||
          item.organization_id != ""
      );

      let FiiledAddress = Address?.filter(
        (item) =>
        
          item.address_line1 != "" ||
          item.address_line2 != "" ||
          item.address_line3 != "" ||
          item.general_city_id != "" ||
          item.postal_code != "" ||
          item.organization_person_id  != "" ||
          item.organization_id != ""
      );

      let FiiledContact = Contact?.filter(
        (item) =>
          item.organization_person_id != "" ||
          item.personal_phone_number != "" ||
          item.alternate_personal_phone_number!= "" ||
          item.personal_email != "" ||
          item.emergency_person_name_1 != "" ||
          item.emergency_person_relation_1 != "" ||
          item.emergency_person_phone_number_1 != "" ||
          item.organization_id != ""
      );

      let FiiledExperience = Experience?.filter(
        (item) =>
          item.organization_name ||
          item.work_title != "" ||
          item.organization_person_id  != "" ||
          item.work_mode != "" ||
          item.experience_type != "" ||
          item.compensation_status != "" ||
          item.general_industry_id != "" ||
          item.start_date != "" ||
          item.end_date != "" ||
          item.currency_code != "" ||
          item.compensation_amount != "" ||
          item.location != "" ||
          item.reporting_manager_name != "" ||
          item.reporting_manager_contact != "" ||
          item.description != "" ||
          item.is_verified != "" ||
          item.verified_by != "" ||
          item.verification_date != "" ||
          item.verification_notes != "" ||
          item.organization_id != ""
      );

      let FiiledMedical = Medical?.filter(
        (item) =>
          item.organization_person_id  != "" ||
          item.blood_group != "" ||
          item.allergies != "" ||
          item.diseases != "" ||
          item.disability_status != "" ||
          item.disability_description != "" ||
          item.is_fit_for_duty != false ||
          item.last_health_check_date != "" ||
          item.medical_notes != "" ||
          item.organization_id != ""
      );
console.log("PaymentMethod",PaymentMethod);

      let FiiledPaymentMethod = PaymentMethod?.filter(
        (item) =>
          item.organization_id != "" ||
          item.organization_person_id  != "" ||
          item.account_holder_name != "" ||
          item.bank_name != "" ||
          item.branch_name != "" ||
          item.swift_code != "" ||
          item.iban_number != "" ||
          item.ifsc_code != "" ||
          item.account_number != "" ||
          item.is_primary != "" ||
          item.wallet_id != "" ||
          item.upi_id != "" ,
      );

      let FiiledDocument = Document?.filter(
        (item) =>
          item.organization_id != "" ||
          item.organization_person_id != "" ||
          item.intern_document_type_id != "" ||
          item.document_name != "" ||
          item.document_url != "" ||
          item.document_size_kb!="" ||
          item.organization_employee_profile_section_id != ""
      );

      if (FiiledEducation?.length > 0) {
        if (!validateForm2()) return;
      }

      if (FiiledLanguage?.length > 0) {
        if (!validateForm3()) return;
      }
      if (FiiledFamily?.length > 0) {
        if (!validateForm9()) return;
      }
      if (FiiledAddress?.length > 0) {
        if (!validateForm4()) return;
      }
      if (FiiledContact?.length > 0) {
        if (!validateForm5()) return;
      }
      if (FiiledExperience?.length > 0) {
        if (!validateForm6()) return;
      }
      if (FiiledMedical?.length > 0) {
        if (!validateForm7()) return;
      }
      if (FiiledPaymentMethod?.length > 0) {
        if (!validateForm8()) return;
      }

      if (FiiledDocument?.length > 0) {
        if (!validateForm10()) return;
      }

      const formData = new FormData();

      const skipEmptyIntegerFields = new Set([
        "organization_internship_status_id",
        "organization_internship_stage_id",
        "organization_internship_type_id",
        "organization_unit_id",
        "organization_department_location_id",
        "organization_work_shift_id",
        "mentor_organization_person_id",
        "organization_user_id",
      ]);

      // Employee fields - Ensure organization_person_id is used instead of intern_id
      Object.entries(Intern).forEach(([key, value]) => {
        // Skip intern_id if it exists, use organization_person_id instead
        if (key === "intern_id") {
          return; // Don't send intern_id
        }
        
        if (key === "profile_image_url" && value instanceof File) {
          formData.append("profile_image_url", value);
        } else if (
          skipEmptyIntegerFields.has(key) &&
          (value === "" || value === null || value === undefined)
        ) {
          return;
        } else if (value !== null && value !== undefined && value !== "") {
          formData.append(key, value);
        } else if (!skipEmptyIntegerFields.has(key)) {
          formData.append(key, value ?? "");
        }
      });
      
      // Ensure organization_person_id is included if Intern has it
      if (Intern.organization_person_id) {
        formData.append("organization_person_id", Intern.organization_person_id);
      }

      const isCreate = mode !== "edit";

      if (isCreate) {
        // ADD MODE: send sections with store1 in ONE atomic transaction.
        const jsonSections = {};
        if (FiiledEducation?.length > 0) jsonSections.education = FiiledEducation;
        if (FiiledLanguage?.length > 0) jsonSections.language = FiiledLanguage;
        if (FiiledFamily?.length > 0) jsonSections.family = FiiledFamily;
        if (FiiledAddress?.length > 0) jsonSections.address = FiiledAddress;
        if (FiiledContact?.length > 0) jsonSections.contact = FiiledContact;
        if (FiiledExperience?.length > 0) jsonSections.experience = FiiledExperience;
        if (FiiledMedical?.length > 0) jsonSections.medical = FiiledMedical;
        if (FiiledPaymentMethod?.length > 0) {
          jsonSections.payment_method = FiiledPaymentMethod;
        }
        if (Object.keys(jsonSections).length > 0) {
          formData.append("sections", JSON.stringify(jsonSections));
        }

        const appendRows = (key, rows) => {
          rows.forEach((item, index) => {
            Object.keys(item).forEach((field) => {
              const value = item[field];
              if (value instanceof File) {
                formData.append(`${key}[${index}][${field}]`, value);
              } else if (Array.isArray(value)) {
                value.forEach((v, arrIndex) => {
                  formData.append(`${key}[${index}][${field}][${arrIndex}]`, v);
                });
              } else if (typeof value === "boolean") {
                formData.append(`${key}[${index}][${field}]`, value ? 1 : 0);
              } else if (value !== null && value !== undefined && value !== "") {
                formData.append(`${key}[${index}][${field}]`, value);
              }
            });
          });
        };
        if (FiiledDocument?.length > 0) appendRows("document", FiiledDocument);
      }

      const response = await axios.post(
        `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-store/store1`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      // Merge person data from org_persons.person into intern BEFORE formatting dates
      const mergedInternData = buildInternStateFromApiResponse(
        response?.data?.intern,
        Intern || {}
      );

      setIntern(mergedInternData);

      console.log("data ishn", response.data)

      if (response.data.education?.length > 0) {
        setEducation(response.data.education);
      }
      if (response.data.language?.length > 0) {
        setLanguage(response.data.language);
      }
      if (response.data.family?.length > 0) {
        setFamily(response.data.family);
      }
      if (response.data.address?.length > 0) {
        setAddress(response.data.address);
      }
      if (response.data.contact?.length > 0) {
        setContact(response.data.contact);
      }
      if (response.data.experience?.length > 0) {
        setExperience(response.data.experience);
      }
      if (response.data.medical?.length > 0) {
        setMedical(response.data.medical);
      }
      if (response.data.payment_method?.length > 0) {
        setPaymentMethod(response.data.payment_method);
      }
      if (response.data.document?.length > 0) {
        setDocument(response.data.document);
      }

      // Get organization_person_id from the intern data returned by store1
      let inter_id = response?.data?.intern?.organization_person_id;
      
      if (!inter_id) {
        console.error("organization_person_id not found in intern response:", response?.data?.intern);
        toast.error("Failed to get intern organization_person_id. Please try again.");
        return;
      }
      
      console.log("Extracted organization_person_id from store1 response:", inter_id);
      console.log("FiiledEducation is:", FiiledEducation);
      console.log("FiiledPaymentMethod is:", FiiledPaymentMethod);


      let sectionData = {}; // This will hold all sections

      // Prepare documents as FormData if there is any - Remove intern_id and ensure organization_person_id is set
      if (FiiledDocument?.length > 0) {
        sectionData.document = Document?.map((item) => {
          const { intern_id, ...rest } = item; // Remove intern_id
          return {
            ...rest,
            organization_person_id: inter_id, // Use organization_person_id from store1 response
            document_url:
              item.document_url instanceof File
                ? item.document_url
                : item.document_url || "",
          };
        });
      }

      // Prepare other sections - Remove intern_id and ensure organization_person_id is set
      if (FiiledEducation?.length > 0) {
        sectionData.education = Education?.map((item) => {
          const { intern_id, ...rest } = item; // Remove intern_id
          const pursuing = Boolean(rest?.is_pursuing);
          return {
            ...rest,
            year_of_passing: pursuing ? "" : rest.year_of_passing,
            organization_person_id: inter_id, // Use organization_person_id from store1 response
          };
        });
      }

      if (FiiledLanguage?.length > 0) {
        sectionData.language = Language?.map((item) => {
          const { intern_id, ...rest } = item; // Remove intern_id
          return {
            ...rest,
            organization_person_id: inter_id, // Use organization_person_id from store1 response
          };
        });
      }

      if (FiiledFamily?.length > 0) {
        sectionData.family = Family?.map((item) => {
          const { intern_id, ...rest } = item; // Remove intern_id
          return {
            ...rest,
            organization_person_id: inter_id, // Use organization_person_id from store1 response
          };
        });
      }

      if (FiiledAddress?.length > 0) {
        sectionData.address = Address?.map((item) => {
          const { intern_id, ...rest } = item; // Remove intern_id
          return {
            ...rest,
            organization_person_id: inter_id, // Use organization_person_id from store1 response
          };
        });
      }

      if (FiiledContact?.length > 0) {
        sectionData.contact = Contact?.map((item) => {
          const { intern_id, ...rest } = item; // Remove intern_id
          return {
            ...rest,
            organization_person_id: inter_id, // Use organization_person_id from store1 response
          };
        });
      }

      if (FiiledExperience?.length > 0) {
        sectionData.experience = Experience?.map((item) => {
          const { intern_id, ...rest } = item; // Remove intern_id
          return {
            ...rest,
            organization_person_id: inter_id, // Use organization_person_id from store1 response
          };
        });
      }

      if (FiiledMedical?.length > 0) {
        sectionData.medical = Medical?.map((item) => {
          const { intern_id, ...rest } = item; // Remove intern_id
          return {
            ...rest,
            organization_person_id: inter_id, // Use organization_person_id from store1 response
          };
        });
      }

      if (FiiledPaymentMethod?.length > 0) {
        sectionData.payment_method = PaymentMethod?.map((item) => {
          const { intern_id, ...rest } = item; // Remove intern_id
          return {
            ...rest,
            organization_person_id: inter_id, // Use organization_person_id from store1 response
          };
        });
      }

      // Check if any section exists before sending.
      // In ADD mode sections were already saved atomically with store1,
      // so store2 is only needed when editing an existing intern.
      if (
        !isCreate &&
        (FiiledEducation?.length > 0 ||
        FiiledLanguage?.length > 0 ||
        FiiledFamily?.length > 0 ||
        FiiledAddress?.length > 0 ||
        FiiledContact?.length > 0 ||
        FiiledExperience?.length > 0 ||
        FiiledMedical?.length > 0 ||
        FiiledPaymentMethod?.length > 0 ||
        FiiledDocument?.length > 0)
      ) {
        // If there are documents as File objects, use FormData
        let finalData;
        let headers = {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        };

        const hasFile = FiiledDocument?.some(
          (doc) => doc.document_url instanceof File
        );


        console.log("section data is ", sectionData)
        if (hasFile) {
          finalData = new FormData();

          Object.keys(sectionData).forEach((key) => {
            sectionData[key].forEach((item, index) => {
              Object.keys(item).forEach((field) => {
                const value = item[field];

                if (value instanceof File) {
                  finalData.append(`${key}[${index}][${field}]`, value);
                } else if (Array.isArray(value)) {
                  // Append each array element individually
                  value.forEach((v, arrIndex) => {
                    finalData.append(
                      `${key}[${index}][${field}][${arrIndex}]`,
                      v
                    );
                  });
                } else if (typeof value === "boolean") {
                  finalData.append(`${key}[${index}][${field}]`, value ? 1 : 0);
                } else if (typeof value === "number") {
                  finalData.append(`${key}[${index}][${field}]`, value);
                } else {
                  finalData.append(`${key}[${index}][${field}]`, value ??"");
                }
              });
            });
          });
        } else {
          finalData = sectionData;
          headers["Content-Type"] = "application/json";
        }

        // try {
        //   console.log("----- FormData Contents -----");
        //   for (let pair of finalData.entries()) {
        //     console.log("helloe ", pair[0], ":", pair[1]);
        //   }
        //   console.log("-----------------------------");
        // } catch (error) {
        //   console.log("erropr is ", error);
        // }

console.log("final data entruy is ", finalData)


        const response2 = await axios.post(
          `${MAIN_URL}/api/organizations/${org?.organization_id}/intern-store/store2`,
          finalData,
          { headers }
        );
      }

      console.log("Submitted successfully:", response.data);
      toast.success(
        `Intern data ${mode == "edit" ? "Edited" : "Added"} successfully!`
      );
      if (
        response?.data?.face_enrollment &&
        response.data.face_enrollment.enrolled === false &&
        response.data.face_enrollment.reason !== "removed"
      ) {
        toast.warning(
          response.data.face_enrollment.message ||
            "Photo saved, but face was not enrolled for attendance. Use a clear front-facing photo."
        );
      } else if (response?.data?.face_enrollment?.enrolled === true) {
        toast.success("Face enrolled for attendance automatically.");
      }
      resetData();
      navigate(-1);
    } catch (error) {
      if (error.response?.data?.errors) {
        let hasEducationError =
          error.response.data.errors.education != undefined;
        let hasLanguageError = error.response.data.errors.language != undefined;
        let hasFamilyError = error.response.data.errors.family != undefined;
        let hasAddressError = error.response.data.errors.address != undefined;
        let hasContactError = error.response.data.errors.contact != undefined;

        let hasExperienceError =
          error.response.data.errors.experience != undefined;
        let hasMedicalError = error.response.data.errors.medical != undefined;
        let hasPaymentMethodError =
          error.response.data.errors.payment_method != undefined;

        let hasDocumentError = error.response.data.errors.document != undefined;

        if (error.response.data.section === "intern") {
          const errors = error.response.data.errors;
          const firstSection = Object.keys(errors)[0];
          setInternErrors(error.response.data.errors);
          toast.error(
            `Validation error in ${firstSection == "intern_code" && "Intern Code"}: ${firstSection == "intern_code" && "The Intern code is already taken"}`
          );
        } else if (hasEducationError) {
          const errors = error.response.data.errors;
          const educationErrorsArray = errors?.education ??[];
          if (educationErrorsArray?.length > 0) {
            const educationErrors = educationErrorsArray[0];
            setEducationError(educationErrors);
            const firstField = Object.keys(educationErrors)[0];
            const firstMessage = educationErrors[firstField][0];
            toast.error(`Validation error in ${firstField}: ${firstMessage}`);
          }
        } else if (hasLanguageError) {
          const errors = error.response.data.errors;
          const languageErrorsArray = errors?.language ??[];
          if (languageErrorsArray?.length > 0) {
            const languageErrors = languageErrorsArray[0];
            setLanguageErrors(languageErrors);
            const firstField = Object.keys(languageErrors)[0];
            const firstMessage = languageErrors[firstField][0];
            toast.error(`Validation error in ${firstField}: ${firstMessage}`);
          }
        } else if (hasFamilyError) {
          const errors = error.response.data.errors;
          const familyErrorsArray = errors?.family ??[];
          if (familyErrorsArray?.length > 0) {
            const familyErrors = familyErrorsArray[0];
            setFamilyError(familyErrors);
            const firstField = Object.keys(familyErrors)[0];
            const firstMessage = familyErrors[firstField][0];
            toast.error(`Validation error in ${firstField}: ${firstMessage}`);
          }
        } else if (hasAddressError) {
          const errors = error.response.data.errors;
          const addressErrorsArray = errors?.address ??[];
          if (addressErrorsArray?.length > 0) {
            const addressErrors = addressErrorsArray[0];
            setAddressError(addressErrors);
            const firstField = Object.keys(addressErrors)[0];
            const firstMessage = addressErrors[firstField][0];
            toast.error(`Validation error in ${firstField}: ${firstMessage}`);
          }
        } else if (hasContactError) {
          const errors = error.response.data.errors;
          const contactErrorsArray = errors?.contact ?? [];
          if (contactErrorsArray?.length > 0) {
            const normalized = {};
            contactErrorsArray.forEach((fieldErrors, idx) => {
              if (!fieldErrors || typeof fieldErrors !== "object") return;
              normalized[idx] = {};
              Object.keys(fieldErrors).forEach((field) => {
                const messages = fieldErrors[field];
                normalized[idx][field] = Array.isArray(messages)
                  ? messages[0]
                  : messages;
              });
            });
            setContactError(normalized);
            const firstIndex = Object.keys(normalized)[0];
            const firstField = Object.keys(normalized[firstIndex] || {})[0];
            const firstMessage = normalized[firstIndex]?.[firstField];
            toast.error(
              firstMessage || "Validation error in Contacts section."
            );
          }
        } else if (hasExperienceError) {
          const errors = error.response.data.errors;
          const experienceErrorsArray = errors?.experience ??[];
          if (experienceErrorsArray?.length > 0) {
            const experienceErrors = experienceErrorsArray[0];
            setExperienceError(experienceErrors);
            const firstField = Object.keys(experienceErrors)[0];
            const firstMessage = experienceErrors[firstField][0];
            toast.error(`Validation error in ${firstField}: ${firstMessage}`);
          }
        } else if (hasMedicalError) {
          const errors = error.response.data.errors;
          const medicalErrorsArray = errors?.medical ??[];
          if (medicalErrorsArray?.length > 0) {
            const medicalErrors = medicalErrorsArray[0];
            setEducationError(medicalErrors);
            const firstField = Object.keys(medicalErrors)[0];
            const firstMessage = medicalErrors[firstField][0];
            toast.error(`Validation error in ${firstField}: ${firstMessage}`);
          }
        } else if (hasPaymentMethodError) {
          const errors = error.response.data.errors;
          const PaymentmethodErrorsArray = errors?.payment_method ??[];
          if (PaymentmethodErrorsArray?.length > 0) {
            const PaymentmethodErrors = PaymentmethodErrorsArray[0];
            setEducationError(PaymentmethodErrors);
            const firstField = Object.keys(PaymentmethodErrors)[0];
            const firstMessage = PaymentmethodErrors[firstField][0];
            toast.error(`Validation error in ${firstField}: ${firstMessage}`);
          }
        } else if (hasDocumentError) {
          const errors = error.response.data.errors;
          const DocumentErrorsArray = errors?.document ??[];
          if (DocumentErrorsArray?.length > 0) {
            const DocumentErrors = DocumentErrorsArray[0];
            setDocumentError(DocumentErrors);
            const firstField = Object.keys(DocumentErrors)[0];
            const firstMessage = DocumentErrors[firstField][0];
            toast.error(`Validation error in ${firstField}: ${firstMessage}`);
          }
        }
        console.error("Validation Errors:", error.response);
      } else {
        console.error("Submit Error:", error);
        const details = error.response?.data?.details || "";
        if (
          typeof details === "string" &&
          details.includes("uq_personal_phone")
        ) {
          setContactError({
            0: {
              personal_phone_number: "Personal phone number already exists.",
            },
          });
          toast.error("Personal phone number already exists.");
        } else if (
          typeof details === "string" &&
          details.includes("uq_personal_email")
        ) {
          setContactError({
            0: { personal_email: "Personal email already exists." },
          });
          toast.error("Personal email already exists.");
        } else if (
          typeof details === "string" &&
          (details.includes("uq_emergency_phone_1") ||
            details.includes("uq_emergency_phone"))
        ) {
          setContactError({
            0: {
              emergency_person_phone_number_1:
                "Emergency contact phone number already exists.",
            },
          });
          toast.error("Emergency contact phone number already exists.");
        } else {
          // Show backend message when available (e.g. SQL constraint duplicates).
          toast.error(
            typeof details === "string" && details.trim()
              ? details
              : error.response?.data?.error ||
                  "Submission failed. Please check the form and try again."
          );
        }
      }
    }
  };

  const handleSubmitClick = async () => {
    setLoading(true);
    try {
      await handleSubmit();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container spacing={2} mt={2}>
      <Grid item>
        <Button
          variant="contained"
       
          color="primary"
          size="medium"
          sx={{
            borderRadius: 2,
            minWidth: 120,
            textTransform: "capitalize",
            fontWeight: 500,
          }}
          onClick={handleSubmitClick}
          disabled={loading  || mode === "view"} // disable while loading
        >
          {loading ? <CircularProgress size={22} color="inherit" /> : "Submit"}
        </Button>
      </Grid>

      {mode === "edit" && (
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={() => navigate(-1)}
            sx={{
              borderRadius: 2,
              minWidth: 120,
              textTransform: "capitalize",
              fontWeight: 500,
              ml: 2, // space between Submit/Edit and Cancel
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#115293" },
            }}
          >
            Cancel
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default SubmitButtonIntern;
